<div class="grid-container padding-y-4">
    <form [formGroup]="hhgCsvDownloadForm">
        <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <legend class="usa-legend usa-legend--large">
                    HHG Rates Download
                </legend>
            </div>
        </div>

        <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="effective_dates" class="usa-label">Rate Effective Dates<abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                <select id="effective_dates" class="usa-select maxw-full" formControlName="effectiveDates"
                    (change)="effectiveDatesChange($event.target.value)" required>
                    <option value='' selected disabled>Choose...</option>
                    <option *ngFor="let rateBidCycle of ratesBidcyclesList" [value]="rateBidCycle.ratesBidcyclesId">
                        {{rateBidCycle.bidCycleName}} ( {{rateBidCycle.rateEffectiveDate | date:'mediumDate':'UTC'}} -
                        {{rateBidCycle.rateExpiryDate | date:'mediumDate':'UTC'}} )
                    </option>
                </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="effective_dates" class="usa-label">Transportation Type<abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                <select id="effective_dates" class="maxw-full usa-select" formControlName="transType"
                    (change)="transportationTypeChange()" required>
                    <option value='' selected disabled>Choose...</option>
                    <option *ngFor="let transportType of transportationList" [ngValue]="transportType">
                        {{ transportType.Text }}
                    </option>
                </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="rate-type" class="usa-label">Rate Type<abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                <select id="rate-type" class="maxw-full usa-select" formControlName="rateType"
                    (change)="rateTypeChange()" required>
                    <option value='' selected disabled>Choose...</option>
                    <option *ngFor="let rateType of rateTypeList" [ngValue]="rateType">{{rateType.Text}}</option>
                </select>
            </div>
            <div *ngIf="allTranScacFlag"
                class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <p class="define-text-secondary">Note: If for "Transportation Type" either "All" or "International" is
                    selected AND for "SCAC" either "All SCACs" or 10 or more SCACs are selected, you may not select "All
                    Origins" and "All Destinations."</p>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label class="usa-label" for="scac">SCAC<abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                <select id="scac" class="usa-select maxw-full define-height-usa-select" formControlName="scac" size="10"
                    multiple (change)="scacChange($event.target.value)" required>
                    <option value='' selected disabled>Choose...</option>
                    <option value='-1'>All SCACs</option>
                    <option *ngFor="let carrier of carrierList" [value]="carrier.carrierId">
                        {{carrier.scac}} - {{carrier.scacName}}
                    </option>
                </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="sro" class="usa-label">SRO<abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                <select multiple id="sro" class="usa-select maxw-full define-height-usa-select" formControlName="sro"
                    size="10" (change)="sroChange($event.target.value)" required>
                    <option value='' selected disabled>Choose...</option>
                    <option *ngFor="let sro of sroList" [value]="sro.sroMasterId">
                        {{sro.sroId}}
                    </option>
                </select>
            </div>

        </div>
        <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="origin" class="usa-label">Origin<abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                <select id="origin" class="maxw-full usa-select" formControlName="origin"
                    (change)="originChange($event.target.value)" required>
                    <option value='' selected disabled>Choose...</option>
                    <option value='0'>All Origins</option>
                    <option *ngFor="let origin of origin$|async" [value]="origin.stateCountryId">
                        {{origin.stateCountryCode}} - {{origin.stateCountryName }}</option>
                </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label class="usa-label" for="destination">Destination<abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                <select id="destination" class="maxw-full usa-select" formControlName="destination"
                    (change)="destinationChange($event.target.value)" required>
                    <option value='' selected disabled>Choose...</option>
                    <option *ngIf="testAllDest" value='0'>All Destinations</option>
                    <option *ngFor="let destination of destination$|async" [value]="destination.stateCountryId">
                        {{destination.stateCountryCode}} - {{destination.stateCountryName }}</option>
                </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
                <button class="usa-button" [disabled]="!(controlChanged && 
                                           rateTypeChanged && 
                                           scacChanged && 
                                           sroChanged && 
                                           originChanged && 
                                           destinationChanged &&
                                           transportationTypeChange &&
                                           !allOrigDestFlag)" (click)="download()">
                    Download</button>


                <!-- <button class="usa-button" [disabled]="!(controlChanged && 
                            rateTypeChanged && 
                            scacChanged && 
                            sroChanged && 
                            originChanged && 
                            destinationChanged &&
                            transportationTypeChange &&
                            !allOrigDestFlag)" (click)="download2()"> Download-cursor</button>
                <button class="usa-button" [disabled]="!(controlChanged && 
                            rateTypeChanged && 
                            scacChanged && 
                            sroChanged && 
                            originChanged && 
                            destinationChanged &&
                            transportationTypeChange &&
                            !allOrigDestFlag)" (click)="downloadMultiThread()"> Download-multithread</button> -->
            </div>
        </div>
    </form>
</div>